todays-deliveries-date-ui
  .row
    .col-12
      .ui-wrap.form-inline
        .prev-day.btn.btn-outline-success.btn-sm(onClick="{onClickYesterday}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().yesterday}") <
        .date-wrap
          input.form-control(name="" value="{ start }" onInput="{this.onInput}" onChange="{this.onChange}" data-type="date")
        .next-day.btn.btn-outline-success.btn-sm(onClick="{onClickTomorrow}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().tomorrow}") >
  script(type="typescript").
    this.mixin('todays.deliveries.date-ui');
